import { SelectChangeEvent } from '@mui/material';
import { useState } from 'react';
import { Plan } from './MiViewPlanSelector.types';

const useMiViewPlanSelector = (
  defaultPlan: Plan,
  plans: Plan[] | [],
) => {
  const [selectedPlan, setSelectedPlan] = useState<Plan | undefined>(defaultPlan);

  const handleChange = (event: SelectChangeEvent) => {
    setSelectedPlan(plans?.find((plan: Plan) => plan?.id === event.target.value));
  };

  return {
    handleChange,
    selectedPlan,
  };
};

export default useMiViewPlanSelector;
